/*
 * The static upload variants are wrong for social previews in two ways: they
 * keep the source format, so a hero uploaded as PNG ships around 1.7MB where
 * some clients give up on it, and their dimensions target the site's layout
 * rather than the platforms (post-xl is 625x548, below the 1200px a large card
 * wants). The media service resizes and re-encodes on request, which answers
 * both.
 *
 * Passing a height centre-crops to it, passing 0 keeps the source ratio.
 *
 * Video posters cannot use this route - they live inside the video's baseDir
 * rather than being a named image upload, and the route 404s on them - so
 * callers keep serving media.poster as it comes from the API.
 */
const SOCIAL_IMAGE_WIDTH = 1200
const SOCIAL_IMAGE_HEIGHT = 630

// availableSizes is the signal that the media service processed this upload;
// without it there is nothing for the resize route to serve
const resizeUrl = (artistId, media, width, height) =>
  artistId && media?.name && media.availableSizes && media.availableSizes.length
    ? `/services/media/image/${artistId}/${media.name}/${width}/${height}/image.webp`
    : null

export const heroSocialImage = (artist) => {
  const hero = artist?.profile?.imgs?.hero
  if (!hero) {
    return null
  }

  // old uploads stored the path directly
  if (typeof hero === 'string') {
    return hero
  }

  // a hero is authored as a wide banner, so cropping it to the card ratio
  // costs almost nothing
  return resizeUrl(artist?._id, hero, SOCIAL_IMAGE_WIDTH, SOCIAL_IMAGE_HEIGHT)
}

// post media is whatever shape the artist uploaded, and a centre crop to the
// card ratio would cut the subject out of a tall image, so keep the ratio and
// leave any cropping to the platform
export const mediaSocialImage = (artist, media) =>
  resizeUrl(artist?._id, media, SOCIAL_IMAGE_WIDTH, 0)
